<div *ngIf="tipoMensagem == 'success'">
    <div class="alert alert-success"  *ngFor="let item of mensagens">
        {{ item }}
    </div>
</div>
<div *ngIf="tipoMensagem == 'error'">
    <div class="alert alert-error"  *ngFor="let item of mensagens">
        {{ item }}
    </div>
</div>
